import * as React from 'react';

// Types
import type { Event } from '@shopee-user/real-time-metrics-event';

export const MetricsReportContext = React.createContext<{
  reportEvents: (events: Event[]) => void;
}>({
  reportEvents: _ => {
    console.warn(
      'Dummy reportEvents are being used. Please make sure that you have provided the implementation through Context.Provider'
    );
  },
});
